import React from 'react';
import { Section } from '@/pages/LandingComplete';
import SectionHeader from './SectionHeader';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

interface FAQContent {
  title?: string;
  titleHighlight?: string;
  items?: Array<{
    question: string;
    answer: string;
  }>;
}

export function DynamicFAQ({ content }: { content: FAQContent }) {
  const items = content.items || [];

  return (
    <Section id="faq" alternate>
      <SectionHeader 
        number="05" 
        title={content.title || "Häufig gestellte"} 
        highlight={content.titleHighlight || "Fragen"}
      />

      <div className="max-w-4xl mx-auto">
        <Accordion type="single" collapsible className="space-y-4">
          {items.map((item, i) => (
            <AccordionItem 
              key={i} 
              value={`item-${i}`}
              className="bg-card rounded-2xl border border-border px-6 shadow-sm hover:shadow-md transition-shadow"
            >
              <AccordionTrigger className="text-left text-lg font-semibold text-card-foreground py-6 hover:no-underline">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground pb-6 leading-relaxed text-base">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </Section>
  );
}
